module.exports = __webpack_public_path__ + "img/CM-SL-CA-Lincoln-Established.de2ad5c2.jpg";